import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateGroupCommand, OperationsFlags } from '@rocksoft/security-sdk';

@Component({
  selector: 'era-add-group-modal-ui',
  templateUrl: './add-group-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [ReactiveFormsModule],
})
export class AddGroupModalComponent {
  private readonly activeModal = inject(NgbActiveModal);
  private readonly formBuilder = inject(UntypedFormBuilder);

  public readonly addForm: UntypedFormGroup;

  constructor() {
    this.addForm = this.createForm();
  }

  private createForm(): UntypedFormGroup {
    return this.formBuilder.group({
      name: ['', Validators.required],
    });
  }

  closeModal(): void {
    this.activeModal.dismiss();
  }

  add(): void {
    const result: CreateGroupCommand = {
      name: this.addForm.get('name')?.value ?? '',
      defaultOperations: new Set([OperationsFlags.Create]),
    };

    this.activeModal.close(result);
  }
}
